var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chronometer"},[(_vm.timestampEnded)?_c('span',[_vm._v(_vm._s(_vm._f("hhmmss")(_vm.time)))]):_c('span',[_vm._v(_vm._s(_vm._f("hhmmss")(_vm.seconds)))]),_c('i',{staticClass:"far fa-clock"})])
}
var staticRenderFns = []

export { render, staticRenderFns }